module.exports = {
  1: {
    label: 'Household',
    icon: "maps_home_work",
    iconClass: "material-icons-outlined",
  },
  2: {
    label: 'Electronics',
    icon: "smartphone",
    iconClass: "material-icons-outlined",
  },
  3: {
    label: 'Clothing',
    icon: "checkroom",
    iconClass: "material-icons-outlined",
  },
  4: {
    label: 'Music',
    icon: "library_music",
    iconClass: "material-icons",
  },
  5: {
    label: 'Auto',
    icon: "directions_car",
    iconClass: "material-icons-outlined",
  },
  6: {
    label: 'Video',
    icon: "duo",
    iconClass: "material-icons",
  },
  7: {
    label: 'Other',
    icon: "more_horiz",
    iconClass: "material-icons-outlined",
  },
  8: {
    label: "Books",
    icon: "book",
    iconClass: "material-icons",
  },
  9: {
    label: "Family",
    icon: "child_friendly",
    iconClass: "material-icons-outlined",
  },
  10: {
    label: "Games",
    icon: "sports_esports",
    iconClass: "material-icons-outlined",
  },
  11: {
    label: "Sports",
    icon: "sports_football",
    iconClass: "material-icons-outlined",
  },
  12: {
    label: "Tools",
    iconClass: "material-icons",
    icon: "build",
  },  
  13: {
    label: "Free",
    iconClass: "material-icons-outlined",
    icon: "sell",
  }
}
